import React, { useState, useMemo } from 'react';

import { Divider, Grid, makeStyles } from '@gogame/components';

import Menu from '../components/Menu';

import SearchField from './components/SearchField';
import UserPermissionsContext from './UserPermissionsContext';

const useClasses = makeStyles((theme) => ({
  lists: {
    border: `1px solid ${theme.palette.divider}`,
  },
  item: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  container: {
    flexWrap: 'nowrap',
    height: '100%',
  },
}));

const UserPermissions = ({ children, roleSelect }) => {
  const categories = React.Children.toArray(children).map(({ props }) => props);

  const [currentCategory, setCurrentCategory] = useState(categories[0]?.id);

  const currentCategoryProps = useMemo(() => {
    return categories.find(({ id }) => id === currentCategory);
  }, [categories, currentCategory]);

  const classes = useClasses();

  const [searchQuery, setSearchQuery] = useState('');

  const handleChangeSearchQuery = (_, query) => setSearchQuery(query);

  const handleChangeCategory = (_, value) => {
    setCurrentCategory(value);
  };

  return (
    <UserPermissionsContext.Provider
      value={{
        searchQuery,
        currentCategory,
        onChangeCategory: handleChangeCategory,
      }}
    >
      <Grid
        container
        spacing={3}
        direction={'column'}
        className={classes.container}
      >
        <Grid container spacing={3} item>
          {roleSelect ? (
            <Grid item xs={4}>
              {roleSelect}
            </Grid>
          ) : null}
          <Grid item xs={roleSelect ? 8 : 12}>
            <SearchField
              value={searchQuery}
              onChange={handleChangeSearchQuery}
            />
          </Grid>
        </Grid>
        <Grid item fullHeight container>
          <Grid container fullHeight className={classes.lists}>
            <Grid item xs={4}>
              <Menu>{children}</Menu>
            </Grid>
            <Divider orientation={'vertical'} flexItem sx={{ ml: '-2px' }} />
            <Grid item className={classes.item} xs={8}>
              {currentCategoryProps
                ? renderCategoryChildren(currentCategoryProps)
                : null}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </UserPermissionsContext.Provider>
  );
};

export default UserPermissions;

function renderCategoryChildren({ children, id, name, label, options }) {
  return children
    ? React.cloneElement(children, {
        id,
        name,
        label,
        options,
      })
    : null;
}
